export const navigationContent = (organizationStore) => {

    let navTree: Array<IMenuItem> = [];
    if (organizationStore.navigation.length > 0) {
        navTree = organizationStore.navigationTree
            .filter(item => item.enabled)
            .map((item, rootIdx) => {
                const children = item.children
                    .filter(item => item.enabled)
                    .map((item, childIdx) => {
                        const grandchildren = item.children
                            .filter(child => child.enabled)
                            .map((child, grandchildIdx) => {
                                return {
                                    icon: "empty-icon",
                                    label: child.title,
                                    id: `${rootIdx}-${childIdx}-${grandchildIdx}`,
                                    navigationObj: child,
                                };
                            });
                        const settings: IMenuItem = {
                            icon: item.icon,
                            label: item.title,
                            id: `${rootIdx}-${childIdx}`,
                            navigationObj: item,
                        };
                        if (grandchildren && grandchildren.length > 0) {
                            settings.content = grandchildren;
                        }
                        return settings;
                    });
                const settings: IMenuItem = {
                    icon: item.icon || "",
                    label: item.title,
                    id: rootIdx,
                    navigationObj: item,

                };
                if (children && children.length > 0) {
                    settings.content = children;
                }
                return settings;
            });
    }

    return navTree;
}
